// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "算法竞赛",
        "tec": "周强",
        "week": "1-8周",
        "add": "教学楼B座423能动"
      },
      {
        "sub": "劳动与创造",
        "tec": "郝雪燕",
        "week": "18周",
        "add": "实训楼F座303信息"
      }
    ],
    [
      {
        "sub": "嵌入式原理与应用",
        "tec": "杨学成",
        "week": "1-13周",
        "add": "教学楼B座421能动"
      },
      {
        "sub": "劳动与创造",
        "tec": "郝雪燕",
        "week": "18周",
        "add": "实训楼F座303信息"
      }
    ],
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "董海浪",
      "week": "1-8周",
      "add": "图书馆1楼党史+网络数字教育基地"
    },
    {
      "sub": "国家安全教育",
      "tec": "李健",
      "week": "9-12周",
      "add": "教学楼C座114教务"
    },
    0
  ],
  "2": [
    {
      "sub": "人工智能技术",
      "tec": "樊迪",
      "week": "9-16周",
      "add": "实训楼F座102自控"
    },
    [
      {
        "sub": "操作系统原理",
        "tec": "吕海华",
        "week": "1-16单周",
        "add": "教学楼B座222自控"
      },
      {
        "sub": "软件工程",
        "tec": "曹福毅",
        "week": "1-16双周",
        "add": "教学楼B座222自控"
      }
    ],
    {
      "sub": "计算机图形学",
      "tec": "李玉秀",
      "week": "1-8周",
      "add": "实训楼F座307信机"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "Web服务开发",
      "tec": "张欣",
      "week": "1-16周",
      "add": "教学楼B座420能动"
    },
    [
      {
        "sub": "就业创业指导",
        "tec": "于天宇",
        "week": "1-5周",
        "add": "教学楼C座213教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "李健",
        "week": "9-12周",
        "add": "教学楼C座115教务"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    [
      {
        "sub": "人工智能技术",
        "tec": "樊迪",
        "week": "9-16周",
        "add": "实训楼F座103自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "郝雪燕",
        "week": "18周",
        "add": "实训楼F座303信息"
      }
    ],
    [
      {
        "sub": "计算机图形学",
        "tec": "李玉秀",
        "week": "1-8周",
        "add": "实训楼F座304信机"
      },
      {
        "sub": "劳动与创造",
        "tec": "郝雪燕",
        "week": "18周",
        "add": "实训楼F座303信息"
      }
    ],
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "董海浪",
      "week": "1-8周",
      "add": "图书馆1楼党史+网络数字教育基地"
    },
    {
      "sub": "嵌入式原理与应用",
      "tec": "杨学成",
      "week": "1-13单周",
      "add": "实训楼F座401信息"
    },
    0
  ],
  "5": [
    {
      "sub": "操作系统原理",
      "tec": "吕海华",
      "week": "1-16周",
      "add": "实训楼F座401信息"
    },
    {
      "sub": "软件工程",
      "tec": "曹福毅",
      "week": "1-16周",
      "add": "教学楼B座319能动"
    },
    {
      "sub": "Web服务开发",
      "tec": "张欣",
      "week": "1-16周",
      "add": "实训楼F座401信息"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
